import { render, staticRenderFns } from "./partners-map.vue?vue&type=template&id=9f86aee2&"
import script from "./partners-map.vue?vue&type=script&lang=ts&"
export * from "./partners-map.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f86aee2')) {
      api.createRecord('9f86aee2', component.options)
    } else {
      api.reload('9f86aee2', component.options)
    }
    module.hot.accept("./partners-map.vue?vue&type=template&id=9f86aee2&", function () {
      api.rerender('9f86aee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partners-map/partners-map.vue"
export default component.exports